import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { CustomBenefitListItemExtension } from './custom-benefit-list-item.extension';
import { CustomBenefitMetadataExtension } from './custom-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('custom')
    .add(BenefitMetadataExtensionInterface, new CustomBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new CustomBenefitListItemExtension())
    .build(),
);
